import * as z from "zod";
import { bundleInfoSchema } from "./bundle-info";

export const updateBundlePartReturnable = {
  name: "updateBundlePartReturnable" as const,
  input: z.object({
    parentVariantId: z.string().min(1),
    variantId: z.string().min(1),
    partIndex: z.number().int().nonnegative(),
    returnable: z.boolean(),
  }),
  output: bundleInfoSchema,
};
